export default {
  methods: {
    copyToClipboard(text, message = 'Copied to clipboard') {
      navigator.clipboard.writeText(text);
      this.toastSuccess(message);
    },
    readFromClipboard() {
      return navigator.clipboard.readText();
    },
  },
};